import type { I18n } from '@lingui/core';
import type { MessageDescriptor } from '@lingui/core';
import { i18n } from '@lingui/core';

/*
    Use this when you marked some string with msg`some string` (import { msg } from '@lingui/core/macro'). Basically
    this will be used when you can't use const { t } = useLingui(); within a component or a hook
 */
export const translateItem = (name: string | MessageDescriptor): string => {
    if (typeof name === 'string') {
        return name;
    }

    // If no locale is set yet, use the descriptor's message or ID as a fallback
    if (!i18n.locale) {
        return name.message ?? name.id;
    }

    // Otherwise perform a real translation lookup
    return i18n._(name);
};

// Use this when you can't use const { t } = useLingui(); like for msg`some string`
export const translateLazy = (name: string | MessageDescriptor, fallback?: string, inst: I18n = i18n) => {
    let lastLocale: string | undefined;
    let cached: string | undefined;

    return () => {
        const loc = inst?.locale;
        if (cached && loc === lastLocale) return cached;

        if (typeof name === 'string') {
            cached = name;
        } else if (loc) {
            const t = inst._(name);
            cached = t && t !== name.id ? t : (fallback ?? name.message ?? name.id);
        } else {
            cached = fallback ?? name.message ?? name.id;
        }

        lastLocale = loc;
        return cached;
    };
};
